import { noop } from "lodash";
import * as React from "react";
import { useMemo, useState } from "react";

/**
 * This state is just to support sub menus.
 */
type MenuContextValue = {
    hoveredMenuItemId?: string;
    openedSubMenuId?: string;
    setHoveredMenuItem: (id: string) => void;
    setOpenedSubMenu: (id: string) => void;
};

export const MenuContext = React.createContext<MenuContextValue>({ setHoveredMenuItem: noop, setOpenedSubMenu: noop });

export const MenuContextProvider: React.FC = ({ children }) => {
    const [hoveredMenuItemId, setHoveredMenuItem] = useState(null as string);
    const [openedSubMenuId, setOpenedSubMenu] = useState(null as string);

    const value = useMemo<MenuContextValue>(
        () => ({
            hoveredMenuItemId,
            setHoveredMenuItem,
            openedSubMenuId,
            setOpenedSubMenu,
        }),
        [hoveredMenuItemId, openedSubMenuId]
    );

    return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
